import { useCallback, useMemo, useState } from 'react';
import useSearchParamsConfig from './useSearchParamsConfig';

export default function useClientFilters(defaultSearchParams) {
  const filters = useMemo(
    () => ({
      clients: [],
      clientRecordStatusId: null,
      clientPractices: [],
      clientBusinessUnits: [],
      clientSalesRepresentatives: [],
      clientOwners: [],
      clientTags: [],
      clientLocations: [],
      clientIndustries: [],
    }),
    [],
  );

  const [defaultParams] = useState(defaultSearchParams);

  const searchParamsConfig = useSearchParamsConfig();

  const clientSearchParamsConfig = useMemo(
    () => ({
      clients: searchParamsConfig.clients,
      clientRecordStatusId: searchParamsConfig.clientRecordStatusId,
      clientPractices: searchParamsConfig.clientPractices,
      clientBusinessUnits: searchParamsConfig.clientBusinessUnits,
      clientSalesRepresentatives: searchParamsConfig.clientSalesRepresentatives,
      clientOwners: searchParamsConfig.clientOwners,
      clientTags: searchParamsConfig.clientTags,
      clientLocations: searchParamsConfig.clientLocations,
      clientIndustries: searchParamsConfig.clientIndustries,
      ...defaultParams,
    }),
    [searchParamsConfig, defaultParams],
  );

  const mapUrlSearchParams = useCallback((filters) => {
    return {
      clientBusinessUnitId: filters.clientBusinessUnits?.map((v) => v.id),
      clientId: filters.clients?.map((v) => v.id),
      clientIndustryId: filters.clientIndustries?.map((v) => v.id),
      clientLocationId: filters.clientLocations?.map((v) => v.id),
      clientOwnerId: filters.clientOwners?.map((v) => v.id),
      clientPracticeId: filters.clientPractices?.map((v) => v.id),
      clientRecordStatusId: filters.clientRecordStatusId ?? undefined,
      clientSalesRepresentativeId: filters.clientSalesRepresentatives?.map((v) => v.id),
      clientTagId: filters.clientTags?.map((v) => v.id),
    };
  }, []);

  const mapClickThroughParams = useCallback(
    (filters) => ({
      clientId: filters.clients?.map((v) => v.id),
      clientPracticeId: filters.clientPractices?.map((v) => v.id),
      clientBusinessUnitId: filters.clientBusinessUnits?.map((v) => v.id),
      clientRecordStatusId: filters.clientRecordStatusId ?? undefined,
      clientSalesRepresentativeId: filters.clientSalesRepresentatives?.map((v) => v.id),
      clientOwnerId: filters.clientOwners?.map((v) => v.id),
      clientTagId: filters.clientTags?.map((v) => v.id),
      clientLocationId: filters.clientLocations?.map((v) => v.id),
      clientIndustryId: filters.clientIndustries?.map((v) => v.id),
    }),
    [],
  );

  return useMemo(
    () => ({ filters, searchParamsConfig: clientSearchParamsConfig, mapUrlSearchParams, mapClickThroughParams }),
    [filters, clientSearchParamsConfig, mapUrlSearchParams, mapClickThroughParams],
  );
}
